var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"pi-radio-btn-item",class:{
    active: _vm.label == _vm.radio,
    'radio-disabled': _vm.disabled === true || _vm.disabled === '',
  }},[_c('input',{staticClass:"pi-radio-input",attrs:{"type":"radio","name":_vm.groupName,"disabled":_vm.disabled},domProps:{"value":_vm.label},on:{"change":_vm.change}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }